import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';
import { HttpClientModule } from '@angular/common/http';
import { StoreModule } from '@ngrx/store';
import { AppComponent } from './app.component';
import { HomeComponent } from './home/home.component';
import { CoreModule } from './core/core.module';
import { SharedModule } from './shared/shared.module';
import { EffectsModule } from '@ngrx/effects';
import { StoreDevtoolsModule } from '@ngrx/store-devtools';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';

import { environment } from '../environments/environment.prod';
import { AppRoutingModule } from './app-routing.module';
import { PageNotFoundComponent } from './home/page-not-found.component';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { reducers } from './state/reducer';
import { RouterEffects } from './state/effects/router.effects';
import { StoreRouterConnectingModule } from '@ngrx/router-store';
import { UnAuthorizedAccessComponent } from './home/component/un-authorized-access.component';

@NgModule({
  declarations: [
    AppRoutingModule.components,
    UnAuthorizedAccessComponent
  ],
  imports: [
    BrowserModule,
		BrowserAnimationsModule,
	  AppRoutingModule,
    HttpClientModule,
    CoreModule,
		NgbModule,
	  SharedModule,
    StoreModule.forRoot(reducers),
    StoreRouterConnectingModule.forRoot({}),
    EffectsModule.forRoot([RouterEffects]),
    StoreDevtoolsModule.instrument({
      name: 'ATS Devtools',
      maxAge: 25,
      logOnly: environment.production
    })
  ],
  providers: [],
  bootstrap: [AppComponent]
})
export class AppModule { }
